import { render } from "./AlteriEditForm.vue?vue&type=template&id=62285454&scoped=true&ts=true"
import script from "./AlteriEditForm.vue?vue&type=script&lang=ts"
export * from "./AlteriEditForm.vue?vue&type=script&lang=ts"

import "./AlteriEditForm.vue?vue&type=style&index=0&id=62285454&scoped=true&lang=scss"

import exportComponent from "/Users/goodwin/Desktop/Fehrya/Dev_goodwin/tools/easynwk-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62285454"]])

export default __exports__